module.exports = __webpack_public_path__ + "img/deploy-it.c6c000e6.jpg";